import { render, staticRenderFns } from "./timindexOne.vue?vue&type=template&id=61aa5c0d&scoped=true"
import script from "./timindexOne.vue?vue&type=script&lang=js"
export * from "./timindexOne.vue?vue&type=script&lang=js"
import style0 from "./timindexOne.vue?vue&type=style&index=0&id=61aa5c0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aa5c0d",
  null
  
)

export default component.exports